import React, { useState, useEffect,useRef } from "react";
import "./App.css";
import Loader from "./Loader";
export default function Teams() {

  const [cloud, setCloud] = useState(global.getTeamData());
  const [username, setUsername] = useState("User");
  const [activeToken, setActiveToken] = useState('');

  const [loading,setLoading] = useState(true);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(cloud.first_name + ' ' + cloud.last_name + ' is inviting you to download Emorya App and use invitation code '+cloud.referral_code+ ' while signin up.');
      alert('Invitation message copied!');
    } catch (error) {
      console.error('Failed to copy text:', error);
    }
  };


  const shareText = async () => {


    

    const shareData = {
      title: 'Burn Calories and Make Money!',
      text: cloud.first_name + ' ' + cloud.last_name + ' is inviting you to download Emorya App and use invitation code '+cloud.referral_code+ ' while signin up.',
      url: 'https://emorya.com/landing', // Optional: Include a URL
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        const referralMessage = cloud.first_name + ' ' + cloud.last_name + ' is inviting you to download Emorya App and use invitation code '+cloud.referral_code+ ' while signin up.';

        // Construct Telegram share URL
        const telegramShareURL = `https://t.me/share/url?url=${encodeURIComponent('https://emorya.com/landing')}&text=${encodeURIComponent(referralMessage)}`;
        
        // Open Telegram share link
        window.Telegram.WebApp.openTelegramLink(telegramShareURL);
    
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
      
  };


  const getData = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + activeToken);
    const raw = "";
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };
    fetch(global.getBaseUrl()+"/team", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        result = JSON.parse(result);
        if (result.error && result.message.indexOf('Unauthorized') !== -1) {
          console.log('Logout From 6',result);
          global.logoutNow();
        }else{
          setCloud(result);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
        
  };



  useEffect(() => {
    if(activeToken != ''){
      getData();
    }
  },[activeToken])


  useEffect(() => {
    if (localStorage.getItem("USERDATA")) {
      var dd = localStorage.getItem("USERDATA");
      dd = JSON.parse(dd);
      setUsername(dd.name);
      setActiveToken(dd.token);
    }else{
      console.log('Logout From 7');
      global.logoutNow();
    }
  }, []);

  return (
    <>
      <div className="section">
      <Loader loading={loading}></Loader>
        <div
          style={{
            padding: 20,
            textAlign: "left",
            width: "100%",
          }}
        >
          
          <div className="mainHeading">
            <i
              className="fa-solid fa-people-group"
              style={{
                fontSize: 16,
              }}
            ></i>
            &nbsp;&nbsp;Teams
          </div>
          <br />
          <div
            style={{
              textAlign: "center",
              marginTop:0
            }}
          >
             <div className="glowBox" style={{
              textAlign:'left',
              marginTop:5,
              padding:10,
              fontSize:13,
              borderRadius:5

              }}>
                <div style={{
                    float:'right'
                }}><i  onClick={() => {
                  handleCopy();
                }} className="fa-regular fa-copy"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i  onClick={() => {
                  shareText();
                }} className="fa-solid fa-arrow-up-right-from-square"></i></div>
              Invite Code:&nbsp;
              <span style={{
                color:'#db5e9c',
                fontWeight:'bold'
              }}>
              {cloud.referral_code}</span>
                </div>
                <br/>
                <br/>
            <div style={{
                display:'inline-block'
            }}>
            <div className="circle"> 
            <div className="circle" style={{
                width:90,
                height:90
            }}>
                <div
              className="profileImageGreen"
              style={{
                backgroundImage: (cloud.image_url && cloud.image_url != '' && cloud.image_url != null) ? `url(${cloud.image_url})` : '',
                height:80,
                width:80,
                borderRadius: "100%",
                
              }}
            ></div></div>
            </div>
            </div>
           
            <br />
            <strong
              style={{
                fontSize: 14,
              }}
            >
              {cloud.first_name} {cloud.last_name} | {cloud.total_team_members} Member{(cloud.total_team_members == 1) ? '' : 's'}
            </strong>
            <br/>
           
            <br />
            <br />
            <div className="glowBox">
              <div className="hotHeading">Level 1 Members</div>
              <div
                style={{
                  padding: 20,
                  textAlign:'left'
                }}>
                
                {
                  (cloud.teams) ? 

                    cloud.teams.members.map((member) => {
                      return (
                        <div className="teamMember">
                  <div className="profileImage" style={{
                    backgroundImage: (member.image_url && member.image_url != '' && member.image_url != null) ? `url(${member.image_url})` : '',
                  }}></div>
                  <div>
                  {member.first_name} {member.last_name}<br/>
                    {member.total_team_members} Members</div>
                </div>
                      )
                  })
                  
                 :

                  <>
                  
                  </>
                 
                }

              </div>
            </div>

            <br />
            <br />
           

           </div>
        </div>
        <div style={{
            width:'100%',
            height:50,
            padding:20,
            
            backgroundColor:'#161730'
        }}>
              <div className="btn btn-sm btn-light" style={{
              textAlign:'left',
              padding:'10px 10px'
              }}>
                <div style={{
                    float:'right'
                }}><i onClick={() => {
                  handleCopy();
                }}  className="fa-regular fa-copy"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i  onClick={() => {
                  shareText();
                }}  className="fa-solid fa-arrow-up-right-from-square"></i></div>
              Invite Code:&nbsp;
              <span style={{
                color:'#0BBFAB'
              }}>
              {cloud.referral_code}</span>
                </div>

        </div>
        <div className="spacer"></div>
      </div>

    </>
  );
}
